import { GetServerSideProps } from 'next'

import { getRedirect, serverSidePropsFor } from '@/utils/helpers.server'

import TopPage from '..'

export const getServerSideProps: GetServerSideProps = async ({ query, req }) => {
  const redirect = getRedirect('top', query.slug as string)
  if (redirect) return { redirect }

  return serverSidePropsFor(
    `${process.env.NEXT_PUBLIC_EDHREC_JSON_URL_CLOUDFLARE}/pages/top/${query.slug}.json`,
    req.headers,
  )
}

export default TopPage
